import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { SETTINGS } from '../../../constants/paths';
import { BillingDashboard } from './billing-dashboard';
import { InvoiceDetailsPage } from './invoice-details-page/invoice-details-page';

export const BillingRoutes = (props) => {
  return (
    <Switch>
      <Route exact={true} path={SETTINGS.billing} component={BillingDashboard} />
      <Route
        path={`${SETTINGS.billing}/invoice/:invoiceId`}
        component={InvoiceDetailsPage}
      />
    </Switch>
  );
};
